<script>
    import {createEventDispatcher} from "svelte";

    export let schemaName = "";
    const dispatch = createEventDispatcher();
</script>

<div class="button__wrapper headline-s" on:click={() => dispatch('click')}>
    <svg style="margin-right: 16px" width="24" height="24" viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path d="M12 0V24M24 12L0 12" stroke="white"/>
    </svg>
    {schemaName} hinzufügen
</div>

<style>
    .button__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 24px 40px;
        background: var(--black-100);
        color: var(--white-100);
        cursor: pointer;
    }
</style>
